module.exports = __webpack_public_path__ + "static/media/brujula.a7649e99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/brujula.svg
// module id = 94
// module chunks = 0